import { createPortal } from 'react-dom'
import { CheckCircle2, Info, X, XCircle } from 'lucide-react'
import { useToastStore } from '@shared/lib/toast/toast-store'
import type { ToastTone } from '@shared/lib/toast/toast-store'
import {
  closeButton,
  container,
  content,
  description,
  iconError,
  iconInfo,
  iconSuccess,
  item,
  title,
} from './Toaster.css'

function ToastIcon({ tone }: { tone: ToastTone }) {
  if (tone === 'success') {
    return <CheckCircle2 size={18} className={iconSuccess} />
  }
  if (tone === 'error') {
    return <XCircle size={18} className={iconError} />
  }
  return <Info size={18} className={iconInfo} />
}

export function Toaster() {
  const toasts = useToastStore((state) => state.toasts)

  if (typeof document === 'undefined') {
    return null
  }

  return createPortal(
    <div className={container}>
      {toasts.map((entry) => (
        <div
          key={entry.id}
          className={item({ tone: entry.tone })}
          role={entry.tone === 'error' ? 'alert' : 'status'}
          aria-atomic="true"
        >
          <ToastIcon tone={entry.tone} />
          <div className={content}>
            <strong className={title}>{entry.title}</strong>
            {entry.description ? <span className={description}>{entry.description}</span> : null}
          </div>
          <button
            type="button"
            className={closeButton}
            aria-label="Fechar aviso"
            onClick={() => useToastStore.getState().dismiss(entry.id)}
          >
            <X size={16} aria-hidden="true" />
          </button>
        </div>
      ))}
    </div>,
    document.body,
  )
}
